// Pure (no imports but types) so test/tracked-links.guard.spec.ts can load it directly.
import type { TrackedLink } from '../../../hooks/api/useTrackedLinks'

/** Per-person roll-up for People's columns: every live link made for that People key. */
export type PersonLinkSummary = {
  links: TrackedLink[]
  clicks: number
  last_visit_at: string | null
  top_interest: string | null
}

export const summariseByPerson = (links: TrackedLink[]): Map<string, PersonLinkSummary> => {
  const out = new Map<string, PersonLinkSummary>()
  for (const link of links) {
    if (!link.person_key || link.archived_at) continue
    const s = out.get(link.person_key) ?? { links: [], clicks: 0, last_visit_at: null, top_interest: null }
    s.links.push(link)
    s.clicks += link.clicks
    if (link.last_visit_at && (!s.last_visit_at || link.last_visit_at > s.last_visit_at)) s.last_visit_at = link.last_visit_at
    out.set(link.person_key, s)
  }
  // Top interest across ALL of a person's links: sum each interest's counts, Home last
  // (the API's rule, rollUpInterests in tracked-links.rules.ts).
  for (const s of out.values()) {
    const totals = new Map<string, number>()
    for (const l of s.links) for (const i of l.interests ?? []) totals.set(i.interest, (totals.get(i.interest) ?? 0) + i.count)
    const ranked = [...totals.entries()].sort((a, b) => Number(a[0] === 'Home') - Number(b[0] === 'Home') || b[1] - a[1])
    s.top_interest = ranked[0]?.[0] ?? null
  }
  return out
}
